import { memo } from "react";
import { ContactsMobileListItem } from "@/common";
import { SwipeToDelete } from "@/shared/Components";
import type { Person } from "@/services/api";
import type { MaybeType } from "@/shared/types";
import type { ListChildComponentProps } from "react-window";

interface ContactRowProps extends ListChildComponentProps {
  data: {
    persons: Person[];
    handleOpenModal: (person: Person) => void;
    rowClickHandler: (person: Person) => void;
    setSwipedPerson: (personId: MaybeType<string>) => void;
    swipedPerson: MaybeType<string>;
  };
}

export const ContactsRow = memo(({ index, style, data }: ContactRowProps) => {
  const { persons, handleOpenModal, rowClickHandler, setSwipedPerson, swipedPerson } = data;
  const person = persons[index];

  return (
    <div style={style}>
      <SwipeToDelete
        key={person.id}
        onDelete={() => handleOpenModal(person)}
        buttonsWidth={50}
        hideEdit
        setSwipedId={setSwipedPerson}
        swipedId={swipedPerson}
        currentId={person.id}
      >
        <ContactsMobileListItem
          onClick={rowClickHandler}
          person={person}
          swipedPerson={swipedPerson}
        />
      </SwipeToDelete>
    </div>
  );
});
